import { FaChartBar } from "react-icons/fa";
import { FaDiagramProject } from "react-icons/fa6";
import { LuTextQuote } from "react-icons/lu";
import { IoCreate } from "react-icons/io5";
import { HiBuildingOffice } from "react-icons/hi2";
import { GrProjects } from "react-icons/gr";
import { BsBarChartSteps } from "react-icons/bs";


   

export const MenuItems = [
  {
    id:1,
    label:'Statistique',
    link:'/',
    icon: <FaChartBar />
  
  },
  {
    id:2,
    label:'Devis',
    link:'/quote',
    icon: <FaDiagramProject />
  },
  {
    id:3,
    label:'Projects',
    link:'/project',
    icon: <LuTextQuote />
  },
  {
    id:3,
    label:'Create Project',
    link:'/projet',
    icon: <IoCreate />
  },
  {
    id:4,
    label:'Bureau d\'Etude',
    link:'/bureau-etude',
    icon: <HiBuildingOffice />
  }
]

{/* <GrProjects /> */}

